import { get, post } from '../http-calls';

export let getSalesEwipStatus = async (id) => {
    let data = await get(`SalesEwipStatus/${id}`, { useAuthToken: true });
    return data;
};

export const postSalesEwipStatus = async (data) => {
    let res = await post(`SalesEwipStatus`, data, { useAuthToken: true });
    return res;
};
